import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import { customerContainer } from 'src/models'
import {
  IS_BROWSER,
  deleteFromSessionStorage,
  VOLUME_URL,
} from 'config/appConfig'
import { localeKeyValue } from 'src/views/pages/LoginCallback/fixture'
import './styles.scss'
import parse from 'html-react-parser'

class ReEnrollNotificationPopup extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {
      isToShowPopUp = true,
      handleSwitchToMember,
      handleReEnrollAsBrandAffiliate,
      handleSignOut,
    } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-success-modal rounded-md">
        <Modal.Body className="conversion-success-modal">
          <h4 className="text-center">
            {i18nTranslate(
              'ba_to_member_switch_re_enroll_prompt',
              'Re-Enroll to continue'
            )}
          </h4>
          <p className="conversion-success-modal-message mt-4">
            {i18nTranslate(
              'ba_to_member_account_termination_message',
              'Your Brand Affiliate account was terminated for not meeting the minimum DC-SV requirements.'
            )}
          </p>

          <p className="conversion-success-modal-message">
            {parse(
              i18nTranslate(
                'ba_to_member_affiliate_member_wholesale_rewards',
                'If you no longer want to participate as a Brand Affiliate but <strong>want access to wholesale pricing and loyalty rewards, you can re-enroll as a Member</strong> by clicking the "Re-enroll as Member" option below.'
              )
            )}
          </p>
          <p className="conversion-success-modal-message ">
            {i18nTranslate(
              'ba_to_member_re_enrollment_message',
              'Otherwise, Re-Enroll as a Brand Affiliate.'
            )}
          </p>
          <div className="row">
            <div className="col-12">
              <Button
                data-testid="qa-switch-to-member-button"
                className="acknowledge-button rounded-md"
                variant="primary"
                type="submit"
                onClick={handleSwitchToMember}
                block>
                {i18nTranslate(
                  'ba_to_member_re_enroll_as_member',
                  'Re-Enroll as Member'
                )}
              </Button>
            </div>
            <div className="col-12">
              <Button
                className="acknowledge-button rounded-md"
                variant="outline-primary"
                data-testid="qa-re-enroll-button"
                block
                onClick={handleReEnrollAsBrandAffiliate}
                tabIndex={0}>
                {i18nTranslate(
                  'ba_to_member_re_enrollment_of_brand_affiliate',
                  'Re-Enroll as a Brand Affiliate'
                )}
              </Button>
            </div>
            <div className="col-12">
              <Button
                className="acknowledge-button rounded-md"
                variant="outline-primary"
                data-testid="qa-exit-cancel-button"
                block
                onClick={handleSignOut}>
                {i18nTranslate(
                  'ba_to_member_sign_out_prompt',
                  'Not Now, Sign Out'
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ReEnrollNotificationPopup
export { ReEnrollNotificationPopup }
